import React, { EventHandler, FC, SyntheticEvent } from 'react';
import classNames from 'classnames';

import { ChildrenPropType } from 'src/utils/types';
import { UiButton } from 'src/components/UI/Button';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';
import styles from './styles.module.scss';

type Props = {
  title: string;

  icon?: FC<CommonIconProps>;
  suffix?: ChildrenPropType;
  testId?: string;
  onClick?: EventHandler<SyntheticEvent>;
  disabled?: boolean;
  selected?: boolean;
};

export const ItemButton: FC<Props> = ({ title, icon: Icon, suffix, testId, onClick, disabled, selected }) => (
  <UiButton
    className={classNames(styles.item, {
      [styles.isSelected]: selected,
      [styles.disabled]: disabled,
    })}
    dataTestId={testId}
    onClick={onClick}
  >
    {Icon && <Icon className={styles.icon} />}

    {title}

    {suffix}
  </UiButton>
);
